import { Action } from '@ngrx/store';

import * as actions from './location.actions';

export interface State {
  loading: boolean;
  address?: Object;
  location?: any;
  error?: any;
}

const INITIAL_STATE: State = {
  loading: false
};

export function reducer(state: State = INITIAL_STATE, action: Action) {
  switch (action.type) {
    case actions.REQUEST_LOCATION:
      return { ...state, loading: true };
    case actions.RESPONSE_SUCCESS_LOCATION:
      return { ...state, loading: false, location: (<any>action).payload };
    case actions.RESPONSE_SUCCESS_LOCATION:
      return { ...state, loading: false, error: (<any>action).payload };
  }
  return state;
}

export const getLocation = (state: State) => state.location;
export const isLoading = (state: State) => state.loading;
